// @flow

import { type Amount } from '@tectonics/prs/money';
import { type CheckoutReceipts } from '@tectonics/prs/receipts';

export function getAmountLocalBase(receipts: CheckoutReceipts): Amount {
  return receipts.main.amount_local_base;
}
